import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { HiMenuAlt2 } from "react-icons/hi";
import { motion, AnimatePresence } from "framer-motion";
import { logo, logoLight } from "../../../assets/images";
import Image from "../../designLayouts/Image";
import { navBarList } from "../../../constants";
import Flex from "../../designLayouts/Flex";
import { useLanguage } from "./LanguageContext";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { FaSearch, FaUser, FaUserEdit, FaCaretDown, FaShoppingCart } from "react-icons/fa";
import { useSelector } from "react-redux";
import { paginationItems } from "../../../constants";
import { useContextSelector } from "use-context-selector";
import { StateContext } from "../../../contexts/StateContext";
import toast, { Toaster } from "react-hot-toast";
import {
  ADMIN,
  PUPIL,
  ACCESS_TOKEN,
  ADMIN_TOKEN,
} from "../../../config/Config";

const Header = () => {
  const [showMenu, setShowMenu] = useState(true);
  const [sidenav, setSidenav] = useState(false);
  const [category, setCategory] = useState(false);
  const [brand, setBrand] = useState(false);
  const [show, setShow] = useState(false);
  const [showUser, setShowUser] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const profileRef = useRef(null);
  const ref = useRef();
  const products = useSelector((state) => state.orebiReducer.products);
  const role = useContextSelector(StateContext, (state) => state.role);
  const setRole = useContextSelector(StateContext, (state) => state.setRole);
  const setIsLoggedIn = useContextSelector(StateContext, (state) => state.setIsLoggedIn);


  // New useEffect to persist login state on refresh
  useEffect(() => {
isAuthenticated();
    /*
    const storedRole = localStorage.getItem('userRole');
    if (storedRole) {
      setRole(storedRole);
      setIsLoggedIn(true);
    }
      */
  }, [setRole, setIsLoggedIn]);

  useEffect(() => {
    const handleResize = () => {
      setShowMenu(window.innerWidth >= 768);
    };
    const handleOutsideClick = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowUser(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const filtered = paginationItems.filter((item) =>
      item.productName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredProducts(filtered);
  }, [searchQuery]);
 const isAuthenticated = () => {
    if (localStorage.getItem(ACCESS_TOKEN)) {
      let token = localStorage.getItem(ACCESS_TOKEN);
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace("-", "+").replace("_", "/");
      token = JSON.parse(window.atob(base64));
      if (token.exp <= Math.floor(Date.now() / 1000)) {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(ADMIN_TOKEN);
        setIsLoggedIn(false);
      }
      //CHECK IF USER HAS ROLE_ADMIN
      if (token.rol.length >= 1) {
        if (token.rol[0] && token.rol[0] === "ADMIN") {
          localStorage.setItem(ADMIN_TOKEN, token.rol[0]);
          setRole(token.rol[0]);
        }
        setRole(token.rol[0]);
        return true;
      } else {
        return false;
      }
    }
  };
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const logout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setShowUser(false);
    setRole("");
    toast.success("Logout successfully");
    window.location.href = "/";
  };

  // New filtered list based on login status
  const filteredNavBarList = navBarList.filter(item => {
    if (role && (item.title === "Login" || item.title === "Sign Up")) {
      return false;
    }
    return true;
  });

  return (
    <>
      {/* Unified Header: Top and Bottom */}
      <div className="w-full bg-white sticky top-0 z-50 border-b border-gray-200 shadow-sm">
        {/* Top Navigation Bar */}
        <div className="w-full h-16 md:h-20 bg-white">
          <nav className="h-full px-4 max-w-container mx-auto relative">
            <Flex className="flex items-center justify-between h-full">
              {/* Logo Section */}
              <Link to="/" className="group">
                <div className="flex items-center transition-transform duration-300 group-hover:scale-105">
                  <Image className="w-16 md:w-20 object-cover drop-shadow-md" imgSrc={logo} />
                </div>
              </Link>

              {/* Desktop Navigation Links */}
              <div className="hidden md:flex items-center">
                {showMenu && (
                  <motion.ul
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className="flex items-center space-x-1"
                  >
                    {filteredNavBarList.map(({ _id, title, link }) => (
                      <NavLink
                        key={_id}
                        className={({ isActive }) =>
                          `flex font-medium justify-center items-center px-3 lg:px-4 py-2 text-sm md:text-base transition-all duration-300 rounded-lg mx-1
                          ${isActive
                            ? 'text-blue-600 bg-blue-50 border border-blue-200'
                            : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50 border border-transparent'
                          }`
                        }
                        to={link}
                      >
                        <li className="px-2 py-1">{title}</li>
                      </NavLink>
                    ))}
                  </motion.ul>
                )}
              </div>

              {/* Right-side Icons */}
              <div className="flex items-center space-x-4">
                {/* User Profile Dropdown */}
                <div ref={profileRef} className="relative">
                  {role === ADMIN ? (
                    <div className="flex items-center space-x-4">
                      <div
                        onClick={() => setShowUser(!showUser)}
                        className="flex items-center space-x-1 p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300 cursor-pointer border border-gray-200"
                      >
                        <FaUser className="text-gray-600" />
                        <FaCaretDown className={`text-gray-500 transition-transform duration-300 ${showUser ? 'rotate-180' : ''}`} />
                      </div>
                      <Link to="/cart" className="relative p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300 border border-gray-200">
                        <FaShoppingCart className="text-gray-600" />
                        <span className="absolute -top-1 -right-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full shadow-lg">
                          {products.length > 0 ? products.length : 0}
                        </span>
                      </Link>
                    </div>
                  ) : role === PUPIL ? (
                    <div className="flex items-center space-x-4">
                      <div
                        onClick={() => setShowUser(!showUser)}
                        className="flex items-center space-x-1 p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300 cursor-pointer border border-gray-200"
                      >
                        <FaUser className="text-gray-600" />
                        <FaCaretDown className={`text-gray-500 transition-transform duration-300 ${showUser ? 'rotate-180' : ''}`} />
                      </div>
                      <Link to="/cart" className="relative p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300 border border-gray-200">
                        <FaShoppingCart className="text-gray-600" />
                        <span className="absolute -top-1 -right-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full shadow-lg">
                          {products.length > 0 ? products.length : 0}
                        </span>
                      </Link>
                    </div>
                  ) : (
                    <div className="flex items-center space-x-4">
                      <div
                        onClick={() => setShowUser(!showUser)}
                        className="flex items-center space-x-1 p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300 cursor-pointer border border-gray-200"
                      >
                        <FaUserEdit className="text-gray-600" />
                        <FaCaretDown className={`text-gray-500 transition-transform duration-300 ${showUser ? 'rotate-180' : ''}`} />
                      </div>
                      <Link to="/cart" className="relative p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300 border border-gray-200">
                        <FaShoppingCart className="text-gray-600" />
                        <span className="absolute -top-1 -right-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full shadow-lg">
                          {products.length > 0 ? products.length : 0}
                        </span>
                      </Link>
                    </div>
                  )}

                  {/* User Dropdown Menu */}
                  <AnimatePresence>
                    {showUser && (
                      <motion.div
                        initial={{ opacity: 0, y: 10, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 10, scale: 0.95 }}
                        transition={{ duration: 0.2 }}
                        className="absolute top-12 right-0 w-48 bg-white rounded-xl shadow-2xl border border-gray-200 z-50 overflow-hidden"
                      >
                        {role === ADMIN ? (
                          <div className="py-2">
                            <Link onClick={() => setShowUser(false)} to="/myprofile" className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100">
                              <span className="flex items-center space-x-2">
                                <FaUser className="text-blue-500" />
                                <span>My Profile</span>
                              </span>
                            </Link>

                             <Link to="/viewCustomers" onClick={() => setShowUser(false)} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100">
                              All Customers
                            </Link>
                            <Link onClick={() => setShowUser(false)} to="/moneyChitDashboard" className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100">
                              MoneyChit Dashboard
                            </Link>
                            {/* <Link onClick={() => setShowUser(false)} to="/goldChitDashboard" className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100">
                              GoldChit Dashboard
                            </Link> */}
                            <Link onClick={() => setShowUser(false)} to="/AdminChit" className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100">
                              MoneyChit Onboard
                            </Link>

                      


                            <button onClick={logout} className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 transition-colors duration-200">
                              Logout
                            </button>
                          </div>
                        ) : role === PUPIL ? (
                          <div className="py-2">
                            <Link onClick={() => setShowUser(false)} to="/myprofile" className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100">
                              <span className="flex items-center space-x-2">
                                <FaUser className="text-blue-500" />
                                <span>My Profile</span>
                              </span>
                            </Link>
                            <button onClick={logout} className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 transition-colors duration-200">
                              Logout
                            </button>
                          </div>
                        ) : (
                          <div className="py-2">
                            <Link to="/signin" onClick={() => setShowUser(false)} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100">
                              Login
                            </Link>
                            <Link onClick={() => setShowUser(false)} to="/signup" className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100">
                              Sign Up
                            </Link>
                            <Link to="/Chit" onClick={() => setShowUser(false)} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100">
                              Chit
                            </Link>
                            <div className="block px-4 py-3 text-gray-500 cursor-not-allowed">
                              Others
                            </div>
                          </div>
                        )}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                {/* Mobile Menu Toggle */}
                <HiMenuAlt2
                  onClick={() => setSidenav(!sidenav)}
                  className="inline-block md:hidden cursor-pointer w-6 h-6 text-gray-600 hover:text-blue-600 transition-colors duration-300 p-1 rounded-lg bg-gray-50 hover:bg-gray-100 border border-gray-200"
                />
              </div>
            </Flex>
          </nav>
        </div>

        {/* Bottom Header Bar */}
        <div className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 relative">
          <div className="max-w-container mx-auto">
            <Flex className="flex flex-col lg:flex-row items-start lg:items-center justify-between w-full px-4 py-3 lg:py-0 lg:h-16">
              {/* Category Dropdown */}
              <div className="relative">
                <div
                  onClick={() => setShow(!show)}
                  ref={ref}
                  className="flex items-center space-x-2 text-white hover:bg-white/20 transition-all duration-300 rounded-lg px-4 py-3 lg:py-2 cursor-pointer border border-transparent hover:border-white/30"
                >
                  <HiOutlineMenuAlt4 className="w-5 h-5" />
                  <p className="text-sm font-medium">Shop by Category</p>
                </div>

                <AnimatePresence>
                  {show && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      transition={{ duration: 0.2 }}
                      className="absolute top-14 left-0 z-50 bg-white rounded-xl shadow-2xl border border-gray-200 min-w-48 overflow-hidden"
                    >
                      <div className="py-2">
                        {["Anklets", "Bracelets", "Rings", "Toe Ring", "Chit"].map((item, index) => (
                          <Link
                            key={index}
                            to={item === "Chit" ? "/Chit" : "/shop"}
                            onClick={() => setShow(false)}
                            className="block px-4 py-3 text-gray-700 hover:bg-blue-50 transition-colors duration-200 border-b border-gray-100 last:border-b-0"
                          >
                            {item}
                          </Link>
                        ))}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Search Bar */}
              <div className="relative w-full lg:w-96 mt-3 lg:mt-0">
                <div className="relative">
                  <input
                    className="w-full h-12 outline-none placeholder:text-gray-400 placeholder:text-sm bg-white/95 backdrop-blur-sm rounded-xl px-4 pr-12 text-gray-700 border-2 border-white/30 focus:border-white/50 transition-all duration-300 shadow-lg"
                    type="text"
                    onChange={handleSearch}
                    value={searchQuery}
                    placeholder="Search your products here..."
                  />
                  <FaSearch className="absolute right-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                </div>

                {/* Search Results Dropdown */}
                <AnimatePresence>
                  {searchQuery && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      className="absolute top-16 left-0 w-full bg-white rounded-xl shadow-2xl border border-gray-200 max-h-96 overflow-y-auto z-50"
                    >
                      <div className="p-2">
                        {filteredProducts.map((item) => (
                          <div
                            key={item._id}
                            onClick={() => window.location.href = `/product/${item.productName.toLowerCase().toUpperCase().split(" ").join("")}`}
                            className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200 cursor-pointer border-b border-gray-100 last:border-b-0"
                          >
                            <img className="w-16 h-16 object-cover rounded-lg" src={item.img} alt={item.productName} />
                            <div className="flex-1 min-w-0">
                              <p className="font-semibold text-gray-900 truncate">{item.productName}</p>
                              <p className="text-xs text-gray-500 truncate">{item.des}</p>
                              <p className="text-sm font-semibold text-blue-600 mt-1">₹{item.price}</p>
                            </div>
                          </div>
                        ))}
                        {filteredProducts.length === 0 && (
                          <div className="p-4 text-center text-gray-500">
                            No products found
                          </div>
                        )}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Flex>
          </div>
        </div>
      </div>

      {/* Mobile Sidenav */}
      <AnimatePresence>
        {sidenav && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-50"
            onClick={() => setSidenav(false)}
          >
            <motion.div
              initial={{ x: -300 }}
              animate={{ x: 0 }}
              exit={{ x: -300 }}
              transition={{ type: "spring", damping: 30 }}
              className="w-80 h-full bg-gradient-to-b from-blue-900 to-blue-800 relative"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-6">
                <img className="w-28 mb-6" src={logoLight} alt="logo" />

                <ul className="space-y-2">
                  {navBarList.map((item) => (
                    <li key={item._id}>
                      <NavLink
                        to={item.link}
                        onClick={() => setSidenav(false)}
                        className={({ isActive }) =>
                          `block py-3 px-4 rounded-lg transition-colors duration-200 ${isActive
                            ? 'bg-white/20 text-white'
                            : 'text-blue-100 hover:bg-white/10'
                          }`
                        }
                      >
                        {item.title}
                      </NavLink>
                    </li>
                  ))}
                </ul>

                {/* Category Accordion */}
                <div className="mt-6">
                  <div
                    onClick={() => setCategory(!category)}
                    className="flex justify-between items-center py-3 px-4 text-blue-100 cursor-pointer rounded-lg hover:bg-white/10 transition-colors duration-200"
                  >
                    <span className="font-medium">Shop by Category</span>
                    <span className="text-lg">{category ? "−" : "+"}</span>
                  </div>
                  {category && (
                    <motion.ul
                      initial={{ height: 0 }}
                      animate={{ height: "auto" }}
                      className="ml-4 space-y-1 overflow-hidden"
                    >
                      {["New Arrivals", "Anklets", "Bracelets", "Rings"].map((cat, index) => (
                        <li key={index} className="py-2 px-4 text-blue-200 hover:text-white transition-colors duration-200">
                          {cat}
                        </li>
                      ))}
                    </motion.ul>
                  )}
                </div>

                {/* Brand Accordion */}
                <div className="mt-4">
                  <div
                    onClick={() => setBrand(!brand)}
                    className="flex justify-between items-center py-3 px-4 text-blue-100 cursor-pointer rounded-lg hover:bg-white/10 transition-colors duration-200"
                  >
                    <span className="font-medium">Shop by Brand</span>
                    <span className="text-lg">{brand ? "−" : "+"}</span>
                  </div>
                </div>
              </div>

              <button
                onClick={() => setSidenav(false)}
                className="absolute top-4 right-4 w-10 h-10 border border-white/30 text-white rounded-full flex items-center justify-center hover:bg-white/20 transition-colors duration-300"
              >
                <MdClose className="w-5 h-5" />
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <Toaster
        position="bottom-right"
        reverseOrder={false}
        toastOptions={{
          error: {
            duration: 6000,
            style: {
              background: "#EF4444",
              color: "#fff",
              borderRadius: "12px",
              boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
            },
          },
          success: {
            duration: 6000,
            style: {
              background: "#10B981",
              color: "#fff",
              borderRadius: "12px",
              boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
            },
          },
        }}
      />
    </>
  );
};

export default Header;